// Agrupa lo que hay por pedir como lo pide el proveedor: por PRENDA, y dentro por
// TALLA con su cantidad.
//
// La lista plana por jugador era una invencion de la pantalla. Al proveedor no se le
// manda "Daniel necesita un jersey": se le manda "Jersey Flag: 3 medianas, 2 chicas".
// El dueno lo dijo preguntando "¿como agrupo por prenda?".
//
// Las que NO tienen talla no se pueden agrupar (no hay por que agruparlas) y son
// justo donde hay trabajo: se devuelven una por jugador para capturarlas ahi mismo.
export const agruparPorPrendaYTalla = (entregas = [], prendaById = {}) => {
  const porPrenda = new Map()

  ;(entregas || []).forEach((e) => {
    const prenda = prendaById[e.prenda_id]
    if (!prenda) return
    if (!porPrenda.has(e.prenda_id)) {
      porPrenda.set(e.prenda_id, { prenda, total: 0, porTalla: new Map(), sinTalla: [] })
    }
    const g = porPrenda.get(e.prenda_id)
    const cantidad = Number(e.cantidad) || 1
    g.total += cantidad

    if (!e.talla) {
      g.sinTalla.push(e)
      return
    }
    if (!g.porTalla.has(e.talla)) {
      g.porTalla.set(e.talla, { talla: e.talla, cantidad: 0, items: [] })
    }
    const linea = g.porTalla.get(e.talla)
    linea.cantidad += cantidad
    linea.items.push(e)
  })

  return [...porPrenda.values()]
    .map((g) => ({
      prenda: g.prenda,
      total: g.total,
      // Primero lo que mas se pide: es el renglon que el proveedor mira.
      tallas: [...g.porTalla.values()].sort((a, b) => b.cantidad - a.cantidad || String(a.talla).localeCompare(String(b.talla))),
      sinTalla: g.sinTalla,
    }))
    .sort((a, b) => (a.prenda.nombre || '').localeCompare(b.prenda.nombre || ''))
}
